module.exports = __webpack_public_path__ + "media/images/flags/64/Canary-Islands-49a57388a37cdedda562cad218cbf086.png";